import React from "react";
import { InputAdornment } from "@mui/material";
import { User } from "react-feather";
import { CustomTextField } from "../../../styles/forms";

const FirstNameField = ({
  values,
  touched,
  handleChange,
  errors,
  handleBlur,
}) => {
  return (
    <CustomTextField
      label="First Name"
      type="text"
      name="firstName"
      variant="outlined"
      color="secondary"
      value={values.firstName}
      onBlur={handleBlur}
      error={Boolean(touched.firstName && errors.firstName)}
      onChange={handleChange}
      helperText={touched.firstName && errors.firstName}
      fullWidth
      size="small"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <User />
          </InputAdornment>
        ),
      }}
      sx={{
        mb: 4,
      }}
    />
  );
};

export default FirstNameField;
